module.exports = __webpack_public_path__ + "img/ic_job.7189ab80.svg";